import { StateCreator } from 'zustand'
import type { FFEStore } from '../types'
import { CompletedPurchaseOrder } from '../../types/purchaseOrder'

export interface PurchaseOrdersSlice {
  addPurchaseOrder: (name: CompletedPurchaseOrder) => void
  setPurchaseOrders: (purchaseOrders: Array<CompletedPurchaseOrder>) => void
  setLoadingPurchaseOrders: (loading: boolean) => void
  patchCompletedPurchaseOrder: (
    purchaseOrderId: string,
    newPurchaseOrder: Partial<CompletedPurchaseOrder>
  ) => void
}

export const createPurchaseOrdersSlice: StateCreator<
  FFEStore,
  [],
  [],
  PurchaseOrdersSlice
> = (set) => ({
  setLoadingPurchaseOrders: (loading) =>
    set(() => ({
      loadingPurchaseOrders: loading
    })),
  addPurchaseOrder: (newPurchaseOrder) =>
    set((state) => ({
      purchaseOrders: [...state.purchaseOrders, newPurchaseOrder]
    })),

  setPurchaseOrders: (newPurchaseOrders) =>
    set(() => ({
      purchaseOrders: newPurchaseOrders
    })),

  patchCompletedPurchaseOrder: (purchaseOrderId, newPurchaseOrder) => {
    set((state) => ({
      purchaseOrders: state.purchaseOrders.map((purchaseOrder) =>
        purchaseOrder.id === purchaseOrderId
          ? { ...purchaseOrder, ...newPurchaseOrder }
          : purchaseOrder
      )
    }))
  }
})
